/**
 * Group Products HTTP client.
 *
 * Day 14 §5.3.3 Group Products.
 */
import api from "./api";
import type {
  CatalogResponse,
  CatalogFilters,
  CatalogStats,
  BulkCreateInput,
  BulkCreateResponse,
  CategoriesResponse,
} from "@/types/group-products.types";

function unwrap<T>(res: { data: unknown }): T {
  const body = res.data as { success?: boolean; data?: T } | T;
  if (
    body &&
    typeof body === "object" &&
    "data" in (body as Record<string, unknown>) &&
    "success" in (body as Record<string, unknown>)
  ) {
    return (body as { data: T }).data;
  }
  return body as T;
}

export const groupProductsService = {
  async listCatalog(filters: CatalogFilters = {}): Promise<CatalogResponse> {
    const params: Record<string, string> = {};
    if (filters.search) params.search = filters.search;
    if (filters.businessId) params.businessId = filters.businessId;
    if (filters.category) params.category = filters.category;
    if (filters.lowStockOnly) params.lowStockOnly = "true";
    const res = await api.get("/group/products", { params });
    return unwrap<CatalogResponse>(res);
  },

  async getStats(): Promise<CatalogStats> {
    const res = await api.get("/group/products/stats");
    return unwrap<CatalogStats>(res);
  },

  async getCategories(): Promise<string[]> {
    const res = await api.get("/group/products/categories");
    const body = unwrap<CategoriesResponse>(res);
    return body.categories || [];
  },

  async bulkCreate(input: BulkCreateInput): Promise<BulkCreateResponse> {
    const res = await api.post("/group/products/bulk-create", input);
    return unwrap<BulkCreateResponse>(res);
  },
};
